const point = "https://backend.bookify.kz"
//const point = "http://localhost:8000"
const shareLink = "https://i.bookify.kz"

const startpoint = `${point}/api/v1/`

export { point, startpoint, shareLink }